export default __webpack_public_path__ + "static/media/spareParts.ecd66673.svg";